import { Text } from "@otta/design";

export function Subheading({ children }: React.PropsWithChildren<unknown>) {
  return (
    <Text as={"h3"} bold size={1}>
      {children}
    </Text>
  );
}
